<template>

    <v-app>

            <v-app-bar :height ="appBarHeight" app clipped-left color="primary darken-2">
                
                <!-- app bar behaves strangely when it comes to positioning -->

                <!-- <v-btn @click="test"> dfsfsf </v-btn> -->

                <v-row>
                    <span class="white--text ml-4"> Customised Earth Observation-based Information Services (CEOIS) </span>
                </v-row>
                 <!-- <chart-dialog-component :info="st.info" :image-size="32044"></chart-dialog-component> -->

                <v-row no-gutters justify="center">
                    <v-btn tile color="primary" href="/docs">
                            API
                    </v-btn>
                </v-row>

                <v-row no-gutters>
                    <v-col>
                        <v-row no-gutters justify="end" align="center">

                            <a class="mx-4" href="https://www.esa.int">
                                <img :height="appBarHeight/2" alt="Qries" src="/images/esa.png">
                            </a>
                            <a class="mx-4" href="https://www.geocodis.com">
                                <img :height="appBarHeight/2" alt="Qries" src="/images/geocodis.png">
                            </a>
                             <a class="mx-4" href="https://www.zrc-sazu.si/en/node">
                                <img :height="appBarHeight/2" alt="Qries" src="/images/zrc-sazu-2.png">
                            </a>

                        </v-row>
                    </v-col>
            
                </v-row>

              

        
            </v-app-bar>

            <v-navigation-drawer :width="sidebarWidth" app color="primary" clipped>

                <div v-if="ready" class="pt-5 mx-2">

                    <side-bar-selector 
                        :api-client="apiClient"
                        :productTypes="productTypes"
                        :selected-items="selectedItems"
                        :main-map="mainMap"
                        >
                    </side-bar-selector>

                   <v-row key="view-result-btn" justify="center">

                        <v-scroll-x-transition>
                            <v-btn @click="getResult" :loading="loading" v-if="validateInput" class="mt-2" small fab outlined>
                                <v-icon key="submit-icon">mdi-eye</v-icon>
                            </v-btn>
                        </v-scroll-x-transition>

                    </v-row>
                    
                </div>

                <template v-slot:append>
                   <transition name="scroll-x-transition" mode="out-in">

                        <v-sheet v-if="stats" :key="statsKey" outlined color="black" class="my-10 mx-2">
                            <v-card outlined elevation='0' color="primary">

                                    <v-card-title class="py-3">

                                        <v-icon left>
                                            mdi-chart-areaspline
                                        </v-icon>
                                        <span class="text-h6 font-weight-light">Stats</span>

                                        <v-spacer></v-spacer>

                                        <chart-dialog-component v-if="info && info.individual_stats" :info="info" :image-size="imageSize"></chart-dialog-component>

                                        <v-btn :href="downloadLink" download :loading="loading" small icon>
                                            <v-icon>mdi-folder-download</v-icon>
                                        </v-btn>

                                    </v-card-title>

                                    <v-card-text class="pb-2 font-weight-bold">
                                        min : {{ roundedStats.min }} <br>
                                        max : {{ roundedStats.max }} <br>
                                        mean : {{ roundedStats.mean }} <br>
                                        std : {{ roundedStats.std }} <br>
                                    </v-card-text>

                                    <v-slider
                                        v-model="opacity"
                                        color="white"
                                        track-color="black"
                                        hide-details
                                        step="0.01" 
                                        min="0"
                                        max="1"
                                    ></v-slider>
                                                        
                                    <div class="mx-3">
                                        <legend-bar :operation="selectedItems.operation" :min="roundedStats.min" :max="roundedStats.max" :dtype="dtype" :treshold="treshold"></legend-bar>
                                    </div>
                            </v-card>
                        </v-sheet>

                    </transition>
                </template>

            </v-navigation-drawer>

         

            <v-main>
                <v-container fluid class="pa-0">

                    <div id="map" style="height:800px"></div>

                    <div v-if="this.ready" class="layers-select-box">

                        <v-select
                            :items="this.mainMap.dropdownLayers"
                            :item-text="(item) => item.get('name')"
                            v-model="selectedLayer"
                            @change="selectLayer"
                            return-object
                            background-color="white"
                            outlined
                        >
                        </v-select>

                    </div>
        
                </v-container>
            </v-main>

            <feedback-component></feedback-component>

    </v-app>

</template>

<script>
 
import MainMap from '../classes/MainMap';
import ApiClient from '../classes/ApiClient';
import LegendBar from '../components/LegendBar.vue';
import SideBarSelector from '../components/SideBarSelector.vue';
import ChartDialogComponent from '../components/ChartDialogComponent.vue';
import TestData from '../classes/TestData';

export default {

    components: {LegendBar, SideBarSelector, ChartDialogComponent},

    props: {
        productTypes : {
            type: Array,
            required: true,
        }
    },

    data: function() {
        return {

            sidebarWidth: 300,
            appBarHeight: 100,

            apiClient: null,
            mainMap: null,

            selectedItems : {
                productType : null,
                country : null,
                aoi : null,
                operation : 'view',
                date1 : null,
                date2: null,
            },

            stats: null,
            downloadLink: '',
            dtype : '',
            info : {},
            imageSize : 1,

            statsKey: 'stats-key',
            opacity: 0.75,

            selectedLayer : null,

            loading: false,
            ready: false,

            // testPressed: false,
        };
    },

    mounted() {

        // set map size
        let map = document.getElementById('map');
        map.style.height = document.body.clientHeight - this.appBarHeight + 'px';

        // init map
        this.mainMap = new MainMap('map');
        this.mainMap.setImageOpacity(this.opacity);

        // default selected layer
        this.selectedLayer = this.mainMap.setBackgroundLayer(this.mainMap.osm);

        /** @type {ApiClient} */
        this.apiClient = new ApiClient();

        this.ready = true;
    },

    methods: {

        // test: function()
        // {
        //     let testData = new TestData();

        //     this.selectedOperation = "change"
        //     this.stats = testData.chartTestData.stats;
        //     this.statsKey = Math.random().toString(36).substring(2,10); // some random string (so we trigger transition for stats)
        //     this.dtype = testData.chartTestData.dtype;
        //     this.info = testData.chartTestData.info;
        //     this.imageSize = testData.chartTestData.height * testData.chartTestData.width;
        //     this.treshold = testData.chartTestData.treshold;
        // },

        getResult: function() {

            this.loading = true;

            this.apiClient.operation(
                this.selectedItems.productType.id,
                this.selectedItems.aoi.id,
                this.selectedItems.operation,
                this.selectedItems.date1,
                this.selectedItems.date2)

                .then(response => {

                    this.mainMap.setImage(
                        response.data.png,
                        response.data.extent,
                        response.data.crs
                    );

                    this.stats = response.data.stats;
                    this.statsKey = Math.random().toString(36).substring(2,10); // some random string (so we trigger transition for stats)
                    this.downloadLink = response.data.tif;
                    this.dtype = response.data.dtype;
                    this.info = response.data.info;
                    this.imageSize = response.data.height * response.data.width;
                    this.treshold = response.data.treshold;
                })
                .finally(() => {
                    this.loading = false;
                });
        },

        round: function(number, places = 2) {
            return Math.round((number + Number.EPSILON) * places * 10) / (places * 10);
        },

        selectLayer: function(layer) {

            this.mainMap.setBackgroundLayer(layer);
        }

    },

    computed: {

        validateInput: function() {

            if(this.selectedItems.productType && this.selectedItems.aoi && this.selectedItems.operation)
            {
                if(this.selectedItems.operation == 'view')
                    return this.selectedItems.date1 != null;

                return this.selectedItems.date1 != null && this.selectedItems.date2 != null;
            }
                
        },

        roundedStats: function() {

            let _stats = {};

            Object.keys(this.stats).forEach((key) => {
                _stats[key] = this.round(this.stats[key]);
            });

            return _stats;
        }

  },

    watch: {
        opacity: function(val) {
            this.mainMap.setImageOpacity(val);
        },
    }


};
</script>

<style scoped>

    .layers-select-box {
        position: absolute;
        top: 10px;
        right: 10px;
        max-width: 150px;
    }

    .layers-select-box >>>  v-list-item--active {
        background-color: white;
    }


</style>